import { Channel } from "./../agptesting-newview/model/channel";
import {
  ResultViewDTO,
  SampleResultViewDTO,
  ShipToSenderDTO,
} from "./ship-To-Sender";
import { Component, OnInit } from "@angular/core";
import * as jwt_decode from "jwt-decode";
import { ConfirmationService } from "primeng/api";
import {
  AnimalBatch,
  WellType,
} from "../agptesting-newview/model/animalBatch";
import { AuthUtil } from "../common-services/auth-util";
import { MessagesService } from "../messages/messages.service";
import { ErrorHandler } from "../utils/error-handler";
import { APGAdministrationService } from "./apg-administration.service";
import { Comment } from "../agptesting-newview/model/comment";
import { MasterDataService } from "../masterdata/masterdata.service";
import { LabMDM } from "../masterdata/models/lab";
import { SampleHistoryTable } from "../apg-sample-result-view/models/sample-history-table";
import { EventEnvelope } from "./model/event";
import { Order } from "./model/order";
import { DatePipe } from "@angular/common";
import { invoiceDateFormat, InvoiceExport } from "./model/invoice-export";
import { saveAs as saveByFileSaver } from "file-saver";
import { WorkFlow } from "../masterdata/models/workFlow";

@Component({
  selector: "app-apg-administration",
  templateUrl: "./apg-administration.component.html",
  styleUrls: ["./apg-administration.component.css"],
})
export class ApgAdministrationComponent implements OnInit {
  searchSelection = "batch";
  selectedLabId: string;
  searchedBatch: AnimalBatch;
  searchSuccess = false;
  selectedResetStatus: string;
  locked: boolean;
  rushSample: boolean;
  //New Lab Instance
  readonly blueberryAPGUKTeddingtonBatchActionUsers="BlueberryAPGUK-TeddingtonBatchActionUsers";
  readonly blueberryAPGUKTeddingtonLabUsers="BlueberryAPGUK-TeddingtonLabUsers";
  
  readonly blueberryAPGBatchAction = "BlueberryAPGBatchActionUsers";
  readonly blueberryAPGEBEUser = "BlueberryAPGEbersbergLabUsers";
  readonly blueberryDenmarkUser = "BlueberryAPGDenmarkLabUsers";
  readonly blueberryDenmarkBatchAction = "BlueberryAPGDenmarkBatchActionUsers";

  readonly blueberryNetherlandsUser = "BlueberryAPGNederlandLabUsers";
  readonly blueberryCPHUser = "BlueberryAPGCopenhagenLabUsers";
  readonly blueberryNetherlandsBatchAction =
    "BlueberryAPGNederlandBatchActionUsers";
  readonly blueberryCPHBatchAction = "BlueberryAPGCopenhagenBatchActionUsers";
  readonly blueberryCologneUser = "BlueberryAPGCologeneLabUsers";
  readonly blueberryCologneBatchAction = "BlueberryAPGCologeneBatchActionUsers";
  readonly blueberrySwedenUser = "BlueberryAPGSwedenUppsalaLabUsers";
  readonly blueberryswedenBatchAction =
    "BlueberryAPGSwedenUppsalaBatchActionUsers";
  readonly blueberryAPGAnimalAction = "BlueberryAPGAnimalBatchActionUsers";
  readonly blueberryAPGAnimalUser = "BlueberryAPGAnimalLabUsers";

  validRole: boolean;
  mapOfStatusCalls = new Map();
  puid: string;
  blocked = false;
  sampleSearch: boolean = false;
  sampleInfo: any;
  showCommentDialog = false;
  showResultDialog = false;
  sampleType: string = "Sample";
  commentsMap = new Map<string, Comment[]>();
  batchCommentVisibility: Map<string, boolean>;
  batchID: string;
  batchIdPopup: boolean = false;
  batchIdToDeleteSample: string;
  redoReasonsPopup: boolean = false;
  selectedRedoReason: string;
  enteredRedoReason: string;
  selectedRedoStep: string;
  redoReasons: any[];
  destination: string = "";
  statusSelectionList = [
    {label:"Create Batch", value: "CREATE_BATCH"},
    {label: "Scan Complete", value: "SCAN_COMPLETE"},
    { label: "Start Clipping", value: "START_CLIPPING" },
    { label: "Complete Clipping", value: "COMPLETE_CLIPPING" },
    { label: "Start Lysis", value: "START_LYSIS" },
    { label: "Complete Lysis", value: "COMPLETE_LYSIS" },
    { label: "Start Extraction", value: "START_EXTRACTION" },
    { label: "Complete Extraction", value: "EXTRACTION_COMPLETE" },
    { label: 'Received DNA', value: "RECEIVED_DNA" },
    { label: "Complete Batch", value: "COMPLETED" },
    { label: "Cancel Batch", value: "CANCELED"}
  ];

  errorHandler: ErrorHandler = new ErrorHandler();
  removeUnnecessaryPopup: boolean = false;
  parentBatches: string[];
  selectedBatchIdToComplete: string;
  statusListWithArchive: any[];
  selectedLab: LabMDM;
  shipToSenderDTO: ShipToSenderDTO;
  resultView: ResultViewDTO;
  sampleResultView: SampleResultViewDTO;

  samplePosition = "";

  columnHeaders384 = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
  ];
  rowHeaders384 = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
  ];

  tables: SampleHistoryTable[] = [];
  sampleHistory: any;
  reset: any;
  superRush: boolean;

  redoStepList = [
    { label: 'Redo PCR', value: 'Redo_PCR' },
    { label: 'Redo Lysis', value: 'Redo_Lysis' }
  ];
  pcrKitRedoInfoForBatch: any;
  selectedRedoReasonInfo: string;
  redoChannelList:any[]=[];
  askForChannelDisabled:boolean;
  
  redoChannel:string;
  noRedoReasonConfiguredForLab:boolean = false;
  redoReasonsForLab: any[];
  selectedRedoReasonStep:string;
  selectedRedoReasonChannel:string;
  requestJson: string;

  deliveryOrdersList: Array<any>;
  deliveryOrdersCols: any[];
  selectedDeliveryOrder: Order;
  title: string = 'Delivery orders';
  showDeliveryOrder: boolean;
  deliveryOrderJson: string;
  
  workflowlist: any[] = [];
  workFlowData: WorkFlow[] = [];
  workFlowList=[];

  selectedResetWorkflow: any;
  sendersList: any[] = [];
  mapOfSenders = new Map();
  selectedResetSender: any;

  dateFields: string[] = ['receivedDate','completedDate',
    'STR-date','SNP-date','TEST-date'];
  boolenFields: string[] = ['reused','STR', 'STR-P', 'SNP', 'SNP-P', 'TEST'];

  fromDate: Date;
  untilDate: Date;
  deliveryId: string;
  searchedBatchWorkFlowName: string;
  postionEBE:any=[];
  positionCON:any=[];
  strMarker: any;
  genevalue: any;
  samplePopVisible: boolean;
  sampleID: any;
  delivery: any=[];
  ordersOfSample: any=[];
  receivedDate: any;
  resultofSampleData: any;
  deliveryList: any=[];
  batchIDForSample: any=[];
  batchIDOfEBE: any=[];
  batchIDOfCON: any=[];
  statusOfBatchEBE: any=[];
  statusOfBatchCON: any=[];
  receivedEBE: any;
  receivedCON: any;
  uniques: any;
  searchIDUnique: any;
  row1: number;
  col1: number;
  row2:number;
  col2:number;
  parentalResult: any;
  uniquesStrp: any[];
  selectedPlateStepsMap: any;
  dateConversion: Date;
  dateToLocal: any;

  constructor(
    private _messagesService: MessagesService,
    private confirmationService: ConfirmationService,
    private apgAdminService: APGAdministrationService,
    private masterDataService: MasterDataService,
    private datePipe: DatePipe
  ) {}

  ngOnInit() {
    this.selectedLabId = JSON.parse(localStorage.getItem("lab")).lab._id;
    this.puid = localStorage.getItem("PUID");
    this.validRole = this.decideIfBBRoleExists();
    this.reset = [{}];
    this.mapOfStatusCalls.set("CREATE_BATCH", "resetCreateBatch");
    this.mapOfStatusCalls.set("SCAN_COMPLETE", "resetScanComplete");
    this.mapOfStatusCalls.set("START_CLIPPING", "resetStartClipping");
    this.mapOfStatusCalls.set("COMPLETE_CLIPPING", "resetCompleteClipping");
    this.mapOfStatusCalls.set("START_LYSIS", "resetStartLysis");
    this.mapOfStatusCalls.set("COMPLETE_LYSIS", "resetCompleteLysis");
    this.mapOfStatusCalls.set(
      "SAMPLE_RECEPTION_CHECKED",
      "resetSampleReceptionChecked"
    );
    this.mapOfStatusCalls.set("START_EXTRACTION", "resetStartExtraction");
    this.mapOfStatusCalls.set("EXTRACTION_COMPLETE", "resetExtractionComplete");
    this.mapOfStatusCalls.set("RECEIVED_DNA", "resetReceivedDNA");
    this.mapOfStatusCalls.set("START_CYCLING", "resetStartCycling");
    this.mapOfStatusCalls.set("CYCLER_COMPLETE", "resetCyclerComplete");
    this.mapOfStatusCalls.set("ANALYSIS_STARTED", "resetAnalysisStarted");
    this.mapOfStatusCalls.set("ANALYSIS_DONE", "resetAnalysisDone");
    this.mapOfStatusCalls.set("COMPLETED", "resetResultFileSent");
    this.mapOfStatusCalls.set("START_PRECYCLING", "resetStartPreCycling");
    this.mapOfStatusCalls.set("COMPLETE_PRECYCLING", "resetCompletePreCycling");
    this.mapOfStatusCalls.set("ARCHIVE_DEFINED", "resetArchiveDefined");
    this.mapOfStatusCalls.set("ARCHIVED", "resetArchived");
    this.mapOfStatusCalls.set("CANCELED", "cancelBatch");

    this.searchedBatch = new AnimalBatch();
    this.fetchLabDetails();
    this.requestJson = null;
    this.deliveryOrdersCols=[
      { field: 'delivery', header: 'Delivery', showInGrid: true },
      { field: 'sampleId', header: 'Sample ID', showInGrid: true },
      { field: 'reused', header: 'Reused', showInGrid: true },
      { field: 'STR', header: 'STR', showInGrid: true },
      { field: 'STR-P', header: 'STR-P', showInGrid: true },
      { field: 'SNP', header: 'SNP', showInGrid: true },
      { field: 'SNP-P', header: 'SNP-P', showInGrid: true },
      { field: 'TEST', header: 'TEST', showInGrid: true },
      { field: 'status', header: 'Order Status', showInGrid: true },
      { field: 'sampleStatus', header: 'Sample Status', showInGrid: true },
      { field: 'receivedDate', header: 'Received Date', showInGrid: true },
      { field: 'completedDate', header: 'Completed Date', showInGrid: true },
      { field: 'STR-date', header: 'STR Invoiced', showInGrid: true },
      { field: 'SNP-date', header: 'SNP Invoiced', showInGrid: true },
      { field: 'TEST-date', header: 'TEST Invoiced', showInGrid: true },
      { field: 'error', header: 'Error', showInGrid: true }
    ];
    this.showDeliveryOrder=false;
    this.getWorkFlowList();
    this.populateSendersInMap();
  }

  getWorkFlowList(){
    this.masterDataService.getAllActiveWorkFlow(this.selectedLabId).subscribe(results =>{
      this.workFlowData = results.data;
      this.workFlowData.forEach(e=>{
        this.workFlowList.push({label: e.workFlowName, value: e.workFlowName});
      });
    },
    (error: any) => {
      let message = this.errorHandler.handleError(error);
      this._messagesService.addErrorMessage(message);
    });
  }

  getSelectedWorkflow(){
    let selectedWorkFlowData: WorkFlow[] = this.workFlowData.filter(e=> e.displayName === this.searchedBatch.workFlowName );
    if(!selectedWorkFlowData || selectedWorkFlowData.length ==0) {
      this._messagesService.addErrorMessage({ severity: 'error', summary: 'Work flow Not Found', detail: 'Please configure Work flow '+ this.searchedBatch.workFlowName + ' to continue with this batch.' });
    }else{
      this.searchedBatch.workFlow = selectedWorkFlowData[0];
    }
  }

  populateSendersInMap() {
    this.masterDataService.getMapOfSenders(this.selectedLabId, true).subscribe(
      result => {
        if (result.data) {
          Object.entries(result.data).forEach(([key, value]) => {
            this.mapOfSenders.set(key, value);
            let tempSender: any = value;
            let labelValue = tempSender.senderShortName ? tempSender.senderShortName : key;
            this.sendersList.push({ label: labelValue, value: key });
          });
          this.sendersList.sort((a, b) => a.label.localeCompare(b.label));
        }
      },
      error => {
        this._messagesService.addErrorMessage(this.errorHandler.handleError(error));
      }
    );
  }

  onResultFileChange(event) {
    if (event.target.files.length > 1) {
      this._messagesService.addWarningMessage({
        severity: 'error', summary: 'Uploaded more than 1 files!',
        detail: 'Maximum of 1 file can be uploaded!',
      });
      return;
    }
    var file = event.target.files[0];
    this.readFileContent(file).then(
      (result) => {
        this.requestJson = result;
      },
      (error) => {
        console.log("Some error while reading the file contents", error)
        this._messagesService.addErrorMessage({
          severity: 'Error', summary: 'Error', detail: 'Error occurred while reading the file contents, please try again'
        })
      }
    )
  }

  readFileContent(file: File): Promise<string> {
    return new Promise<string>((resolve, reject) => {
      if (!file) {
        resolve('');
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        const text = reader.result.toString();
        resolve(text);
      };
      reader.readAsText(file);
    });
  }

  submitRequest() {
    this.blocked = true;
    let request
    try {
      request = JSON.parse(this.requestJson);
    } catch (error) {
      this.blocked = false;
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'Invalid JSON', detail: error.message
      })
      return;
    }
    if(this.searchSelection=='sendOrder'){
      this.apgAdminService.submitOrder(request).subscribe(
        (result) => {
          this.blocked = false;
          this._messagesService.addSuccessMessage(
            {
              severity: 'success', summary: 'Success',
              detail: 'Order has been accpeted'
            }
          )
        }, (error) => {
          this.blocked = false;
          if (error) {
            let message = this.errorHandler.handleError(error);
            this._messagesService.addErrorMessage(message);
          } else {
            this._messagesService.addErrorMessage({
              severity: 'error', summary: 'Failure',
              detail: 'Some unknown error, please try again'
            })
          }
        }
      )
    }else{
      if(!request || !request.delivery || request.delivery=='' || !request.sampleId || request.sampleId==''){
        this.blocked = false;
        this._messagesService.addWarningMessage(
          {severity: "warn", summary: "Invalid data", 
          detail: "Following fields ['sampleId', 'delivery'] are mandatory to submit request, can't be either null or empty"}
        )
        return;
      }
      let eventEnvelope: EventEnvelope = {} as EventEnvelope;
      eventEnvelope.eventData = request;
      eventEnvelope.date = new Date();
      eventEnvelope.source = "Blueberry UI - Mock";
      eventEnvelope.destination = "Interface";
      eventEnvelope.eventType = "RESULT_UPDATED"
      this.apgAdminService.submitEvent(eventEnvelope).subscribe(
        (response)=>{
          this.blocked = false;
          this._messagesService.addSuccessMessage(
            {
              severity: 'success', summary: 'Success',
              detail: 'Order update request has been accepted'
            }
          )
        },
        (error)=>{
          this.blocked = false;
          if (error) {
            let message = this.errorHandler.handleError(error);
            this._messagesService.addErrorMessage(message);
          } else {
            this._messagesService.addErrorMessage({
              severity: 'error', summary: 'Failed',
              detail: 'Unknown error, please try again'
            })
          }
        }
      );
    }
  }

  searchInterface(searchID: string){
    if(!searchID || searchID==''){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Search ID is empty',
        detail: 'Please input sample id and hit enter or click on Go'
      })
      return;
    }
    this.blocked = true;
    this.apgAdminService.getSampleOrderStatus(searchID).subscribe(
      (response)=>{
        this.blocked = false;
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Success',
          detail: 'Successfully fetched orders information for sample '+searchID
        })
        document.getElementById("orderSearchJsonId").innerHTML = JSON.stringify(response.data, undefined, 2);
      },
      (error)=>{
        this.blocked = false;
        console.log("Error message ", error);
        if (error && error.status=='404' && error.error && error.error.data && error.error.data.length==0) {
          this._messagesService.addErrorMessage(
            {
              severity: 'error', summary: 'Order not found',
              detail: 'No order found with sampleId '+searchID
            }
          )
        } else if(error){
          let message = this.errorHandler.handleError(error);
          this._messagesService.addErrorMessage(message);
        }else {
          this._messagesService.addErrorMessage({
            severity: 'error', summary: 'Unknown error',
            detail: 'Failed to fetch requested information'
          })
        }
      }
    );
  }

  fetchLabDetails() {
    this.masterDataService.findLabById(this.selectedLabId).subscribe(
      (result) => {
        if (
          result.data == null ||
          result.data == undefined ||
          result.data.length == 0
        ) {
          this._messagesService.addErrorMessage({
            severity: "error",
            summary: "Lab not found!",
            detail: "Contact Administrator to resolve this issue.",
          });
          return;
        }
        this.selectedLab = result.data;
      },
      (error) => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  decideIfBBRoleExists() {
    let roles = this.getRolesFromAccessToken();
    if (roles.length > 0) {
      return (
        (roles.includes(this.blueberryAPGUKTeddingtonBatchActionUsers) &&
          roles.includes(this.blueberryAPGUKTeddingtonLabUsers)) ||
        (roles.includes(this.blueberryAPGBatchAction) &&
          roles.includes(this.blueberryAPGEBEUser)) ||
        (roles.includes(this.blueberryDenmarkBatchAction) &&
          roles.includes(this.blueberryDenmarkUser)) ||
        (roles.includes(this.blueberryNetherlandsBatchAction) &&
          roles.includes(this.blueberryNetherlandsUser)) ||
        (roles.includes(this.blueberryCologneBatchAction) &&
          roles.includes(this.blueberryCologneUser)) ||
        (roles.includes(this.blueberryCPHBatchAction) &&
          roles.includes(this.blueberryCPHUser)) ||
        (roles.includes(this.blueberryswedenBatchAction) &&
          roles.includes(this.blueberrySwedenUser)) ||
        (roles.includes(this.blueberryAPGAnimalAction) &&
          roles.includes(this.blueberryAPGAnimalUser))
      );
    }
    return false;
  }

  getRolesFromAccessToken() {
    let authUtil = new AuthUtil();
    let accessToken = authUtil.getAccessToken();
    if (accessToken) {
      let access_token = jwt_decode(accessToken);
      return access_token.roles;
    }
    return [];
  }

  search(searchID: string) {
    this.searchSuccess = false;
    this.sampleSearch = false;
    searchID=searchID.trim();
    if(this.searchSelection == 'batch') {
      this.searchForBatch(searchID)
    }
    else{
      this.searchForSample(searchID);
    }
  }

  searchForBatch(batchID: string) {
    if (!batchID || batchID.trim() == "") {
      this._messagesService.addWarningMessage({
        severity: "warn",
        summary: "Batch ID Empty",
        detail: "Please enter Batch ID to search",
      });
      return;
    }
    this.apgAdminService
      .getBatchForLabAndBatchId(this.selectedLabId, batchID)
      .subscribe(
        (result) => {
          this.searchedBatch = result.data;
          this.commentsMap = new Map<string, Comment[]>();
          this.batchCommentVisibility = new Map<string, boolean>();
          this.batchID = this.searchedBatch.batchID;
          this.resetBatchData();
          this.searchedBatchWorkFlowName = this.searchedBatch.workFlowName;
          this.selectedResetStatus = this.searchedBatch.statusOfTheBatch;
          this.selectedResetSender = this.searchedBatch.sender;
          this.searchSuccess = true;
        },
        (error) => {
          let message = this.errorHandler.handleError(error);
          this._messagesService.addErrorMessage(message);
        }
      );
  }

  redoDisabled() {
    return (
      !this.searchedBatch ||
      this.searchedBatch.statusOfTheBatch == "MERGE_STARTED" ||
      this.isMergedBatch() ||
      ["REDO", "REMOVED"].includes(this.searchedBatch.statusOfTheBatch) ||
      !this.validRole 
    );
  }

  redoLysisDisabled() {
    return (
      this.searchedBatch.swabType == "Wet" &&
      this.searchedBatch.createdFromAnalysis
    );
  }

  resetStatus() {
    let dialogMessage =
      "Do you really want to update the Batch " +
      this.searchedBatch.batchID +
      "?";
    this.confirmationService.confirm({
      message: dialogMessage,
      header: "Confirmation",
      icon: "fa fa-question-circle",
      accept: () => {
        if(this.selectedResetSender && this.selectedResetSender!=''){
          this.searchedBatch.sender = this.selectedResetSender
        }
        if (this.selectedResetStatus) {
          let functionName = this.mapOfStatusCalls.get(
            this.selectedResetStatus
          );
          this[functionName]();
        } else {
          this.saveBatchData();
        }
      },
      reject: () => {
        this.selectedResetStatus = null;
        this.searchedBatch.workFlowName = this.searchedBatchWorkFlowName;
        this.getWorkFlowList();
        this.selectedResetSender = null;
      },
    });
  }

  resetScanComplete() {
    this.searchedBatch.clippingStartDateTime = new Date();
    this.searchedBatch.puidClipping = this.puid;
    this.updateBatch("SCAN_COMPLETE");
  }

  resetCreateBatch() {
    this.searchedBatch.clippingStartDateTime = new Date();
    this.searchedBatch.puidClipping = this.puid;
    this.updateBatch("CREATE_BATCH");
  }

  resetStartClipping() {
    this.searchedBatch.clippingStartDateTime = new Date();
    this.searchedBatch.puidClipping = this.puid;
    this.updateBatch("START_CLIPPING");
  }

  resetCompleteClipping() {
    this.searchedBatch.puidCompleteClipping = this.puid;
    this.searchedBatch.clippingCompletionDateTime = new Date();
    this.updateBatch("COMPLETE_CLIPPING");
  }

  resetSampleReceptionChecked() {
    this.searchedBatch.completenessCheckDateTime = null;
    this.searchedBatch.puidController2 = null;
    this.updateBatch("COMPLETE_CLIPPING");
  }

  resetStartLysis() {
    this.searchedBatch.lysisStartDateTime = new Date();
    this.searchedBatch.puidstartLysis = this.puid;
    this.updateBatch("START_LYSIS");
  }

  resetCompleteLysis() {
    this.searchedBatch.puidCompleteLysis = this.puid;
    this.searchedBatch.lysisCompletionDateTime = new Date();
    this.updateBatch("COMPLETE_LYSIS");
  }

  resetStartExtraction() {
    this.searchedBatch.startExtraction = new Date();
    this.searchedBatch.puidStartExtraction = this.puid;
    this.updateBatch("START_EXTRACTION");
  }

  resetReceivedDNA() {
    this.searchedBatch.completionDateTimeExtraction = new Date();
    this.searchedBatch.puidExtraction = this.puid;
    this.updateBatch("RECEIVED_DNA");
  }

  resetExtractionComplete() {
    this.searchedBatch.completionDateTimeExtraction = new Date();
    this.searchedBatch.puidExtraction = this.puid;
    this.updateBatch("EXTRACTION_COMPLETE");
  }

  resetStartPreCycling() {
    this.searchedBatch.precyclingStartDateTime = null;
    this.searchedBatch.puidstartPrecycling = null;
    this.updateBatch("EXTRACTION_COMPLETE");
  }

  resetCompletePreCycling() {
    this.searchedBatch.precyclingCompletionDateTime = null;
    this.searchedBatch.puidCompletePrecycling = null;
    this.updateBatch("START_PRECYCLING");
  }

  resetStartCycling() {
    this.searchedBatch.startDatePCR = null;
    this.searchedBatch.puidPCR2 = null;
    this.updateBatch("COMPLETE_PRECYCLING");
  }

  resetCyclerComplete() {
    this.searchedBatch.completionDateTimePCR = null;
    this.searchedBatch.puidPCR1 = null;
    this.updateBatch("START_CYCLING");
  }

  resetAnalysisStarted() {
    this.searchedBatch.analysisStartedPUID = null;
    this.searchedBatch.analysisStartedDateTime = null;
    this.updateBatch("CYCLER_COMPLETE");
  }

  resetAnalysisDone() {
    this.searchedBatch.completionDateTimeEvaluation = null;
    this.searchedBatch.puidEvaluation = null;
    this.updateBatch("ANALYSIS_STARTED");
  }

  resetResultFileSent() {
    this.searchedBatch.resultSentDateTime = new Date();
    this.searchedBatch.resultDispatchedyPUID = this.puid;
    this.updateBatch("COMPLETED");
  }

  resetArchiveDefined() {
    this.updateBatch("ARCHIVE_DEFINED");
  }

  resetArchived() {
    this.searchedBatch.archiveProcessedDateTime = new Date();
    this.updateBatch("ARCHIVED");
  }

  cancelBatch() {
    this.searchedBatch.canceledDateTime = new Date();
    this.updateBatch("CANCELED");
  }

  updateBatch(statusOfBatch: string) {
    this.searchedBatch.statusOfTheBatch = statusOfBatch;
    this.searchedBatch.previousStatusOfTheBatch = statusOfBatch;
    this.saveBatchData();
  }

  disableUpdateBatch() {
    return (
      !this.validRole || (this.enableUpdateButton() && !this.selectedResetStatus && (this.searchedBatch.workFlowName==this.searchedBatchWorkFlowName) && !this.selectedResetSender)
    );
  }
  enableUpdateButton() {
    return (
      this.rushSample == this.searchedBatch.rushSample && this.superRush == this.searchedBatch.superRush &&
      this.locked == this.searchedBatch.locked
    );
  }
  saveBatchData() {
    this.searchedBatch.lab = this.selectedLabId;
    this.searchedBatch.userID = this.puid;
    this.blocked = true;
    this.apgAdminService.changeBatchStatus(this.searchedBatch).subscribe(
        (result) => {
          this.blocked = false;
          if (result.data) {
            this.searchedBatch = result.data;
            this.resetBatchData();
            this._messagesService.addSuccessMessage({
              severity: "success", summary: "Batch Updated!",
              detail: "Batch " + this.searchedBatch.batchID + " has been updated successfully",
            });
          }
        },
        (error) => {
          this.blocked = false;
          let message = this.errorHandler.handleError(error);
          this._messagesService.addErrorMessage(message);
        }
      );
  }

  resetBatchData() {
    this.rushSample = this.searchedBatch.rushSample;
    this.superRush = this.searchedBatch.superRush;
    this.locked = this.searchedBatch.locked;
    this.statusListWithArchive = [...this.statusSelectionList];
    if (
      this.searchedBatch.archiveBatchSources &&
      this.searchedBatch.archiveBatchSources.length > 0
    ) {
      this.statusListWithArchive.push({
        label: "Archive Defined",
        value: "ARCHIVE_DEFINED",
      });
      this.statusListWithArchive.push({ label: "Archived", value: "ARCHIVED" });
    }
  }
  redoAction() {
    let repeatLysisMessage = "";
    if (
      this.searchedBatch.redoCount > 0 &&
      this.selectedRedoReasonStep == "Redo_Lysis" &&
      this.searchedBatch.batchID
        .substring(this.searchedBatch.batchID.lastIndexOf("_"))
        .includes("L") &&
      this.searchedBatch.swabType == "Dry"
    ){
      repeatLysisMessage = "This Batch has already undergone Redo Lysis, Are you sure you want to attempt Redo Lysis again?";
    }
    this.confirmationService.confirm({
      message: "Do you really want to Redo " + this.searchedBatch.batchID + "? "+repeatLysisMessage,
      header: "Confirmation",
      icon: "fa fa-question-circle",
      accept: () => {
        if(this.selectedRedoReasonStep == 'Redo_PCR'){
          this.selectedRedoStep = 'EXTRACTION_COMPLETE';
        }else if(this.selectedRedoReasonStep == 'Redo_Lysis'){
          this.selectedRedoStep = 'SAMPLE_RECEPTION_CHECKED';
        }
        this.searchedBatch.redoStep = this.selectedRedoReasonStep;
        this.searchedBatch.redoChannel = this.selectedRedoReasonChannel;

        let redosearchedBatch = this.searchedBatch;
        redosearchedBatch.redoStatus = this.selectedRedoStep;
        redosearchedBatch.redoReason =
          this.selectedRedoReason != "Other"
            ? this.selectedRedoReason
            : this.enteredRedoReason;

        redosearchedBatch.redoDateTime = new Date();
        redosearchedBatch.redoPUID = this.puid;
        this.blocked = true;
        this.apgAdminService.redoBatchService(redosearchedBatch).subscribe(
          (result) => {
            if (result.data) {
              this.searchedBatch = result.data;
              this._messagesService.addSuccessMessage({
                severity: "success",
                summary: "Redo Batch Created!",
                detail:
                  "Redo Batch " +
                  result.data.batchID +
                  " has been created for user " +
                  this.puid,
              });
              this.selectedRedoReason = null;
              this.selectedRedoStep = null;
              this.enteredRedoReason = null;
              this.redoReasonsPopup = false;
            }
            this.blocked = false;
          },
          (error) => {
            this.blocked = false;
            let message = this.errorHandler.handleError(error);
            message.summary = "REDO Error";
            this._messagesService.addErrorMessage(message);
          }
        );
      },
      reject: () => {

      },
    });
  }

  confirmRemoveBatch() {
    let dialogMessage =
      "Do you really want to remove the Batch " +
      this.searchedBatch.batchID +
      "?";
    this.confirmationService.confirm({
      message: dialogMessage,
      header: "Confirmation",
      icon: "fa fa-question-circle",
      accept: () => {
        this.removeBatch();
      },
      reject: () => {

      },
    });
  }

  removeBatch() {
    this.blocked = true;
    this.apgAdminService
      .removeBatch(
        this.selectedLabId,
        JSON.parse(localStorage.getItem("lab")).lab.name,
        this.searchedBatch.batchID
      )
      .subscribe(
        (result) => {
          if (result.data) {
            this._messagesService.addSuccessMessage({
              severity: "success",
              summary: "Batch Removed!",
              detail: result.data,
            });
            this.searchedBatch.statusOfTheBatch = "REMOVED";
            this.searchedBatch.version = this.searchedBatch.version + 1;
          }
          this.blocked = false;
        },
        (error) => {
          let message = this.errorHandler.handleError(error);
          this._messagesService.addErrorMessage(message);
          this.blocked = false;
        }
      );
  }

  assignSamples(result: any) {
    let sampleChannels: any = [];
    this.resultView = new ResultViewDTO();
    this.sampleResultView = new SampleResultViewDTO();
    this.sampleResultView.positionRow = result.positionRow;
    this.sampleResultView.prositionCol = result.positionCol;
    if (result.channels && result.channels.length > 0) {
      result.channels.forEach((channel) => {
        let localChannel: Channel = new Channel(channel.gene);
        localChannel.cpValue = channel.cpValue;
        localChannel.geneResult = channel.geneResult;
        sampleChannels[channel.gene] = localChannel;
      });
    }
    this.sampleResultView.channels = sampleChannels;
    this.sampleResultView.results = result.results;
    this.sampleResultView.result = result.result;
    this.resultView.samples = this.sampleResultView;
    this.resultView.channelTestingTypeMapping =
      result.channelTestingTypeMapping;
  }
  getPositionString(row: number, col: number) {
    if (row != undefined && col != undefined) {
      return String.fromCharCode(64 + row) + col;
    }
  }

  getStyleForResult(result: string) {
    if (result && result.trim() != "") {
      if (result === "positive")
        return {
          color: "red",
        };
      else if (result === "negative")
        return {
          color: "green",
        };
      else
        return {
          color: "#ffbf00",
        };
    }
  }

  getContaminationString(sampleInfo: any): string {
    let contaminationString = "";
    if (
      sampleInfo.contamination &&
      sampleInfo.contamination != "No Contamination"
    ) {
      contaminationString = sampleInfo.contamination;
      if (
        sampleInfo.contaminationComment &&
        sampleInfo.contaminationComment.trim() != ""
      )
        contaminationString =
          contaminationString + "( " + sampleInfo.contaminationComment + " )";
    }
    return contaminationString;
  }

  disableSearchIf(searchID: string): boolean {
    return !searchID || searchID.trim() == "";
  }

  getCommentKeys(commentMap: Map<string, Comment>) {
    return Array.from(commentMap.keys());
  }

  toggleBatchContent(batchID: string, showState: boolean) {
    this.batchCommentVisibility.set(batchID, showState);
  }

  showComments(batchResult: boolean) {
    if (batchResult) {
      this.formCommentsMap(this.searchedBatch.comments, batchResult);
    } else {
      this.formCommentsMap(this.sampleInfo.comment, batchResult);
    }
    this.showCommentDialog = true;
  }

  formCommentsMap(comments: Comment[], batchResult: boolean) {
    if (!comments || this.commentsMap.size != 0) {
      return;
    }
    this.batchCommentVisibility = new Map<string, boolean>();
    comments.forEach((comment) => {
      let cmnt = this.getArrayOfCommentsToAnother(
        comment.batchId,
        comment,
        batchResult
      );
      this.commentsMap.set(comment.batchId, cmnt);
      this.batchCommentVisibility.set(comment.batchId, true);
    });
  }

  getArrayOfCommentsToAnother(
    batchID: string,
    comment: Comment,
    batchResult: boolean
  ) {
    let commentItem = this.commentsMap.get(batchID);
    if (!commentItem) {
      commentItem = [];
    }
    if (!batchResult) {
      comment.commentDate = comment.commentDate["$date"];
    }
    commentItem.push(Object.assign({}, comment));
    return commentItem;
  }

  deleteDisabledIf() {
    return !(
      this.batchIdToDeleteSample && this.batchIdToDeleteSample.trim() != ""
    );
  }

  deleteSample(searchField: HTMLInputElement) {
    let dialogMessage =
      "Do you really want to Delete the Sample " + searchField.value + "?";
    this.confirmationService.confirm({
      message: dialogMessage,
      header: "Confirmation",
      icon: "fa fa-question-circle",
      accept: () => {
        this.blocked = true;
        this.apgAdminService
          .deleteSampleFromBatch(
            this.selectedLabId,
            searchField.value,
            this.batchIdToDeleteSample
          )
          .subscribe(
            (result) => {
              searchField.value = null;
              this.sampleSearch = false;
              this.sampleInfo = null;
              this.batchIdPopup = false;
              this._messagesService.addSuccessMessage({
                severity: "success",
                summary: "Deleted Sample!",
                detail: result.data,
              });
              this.blocked = false;
            },
            (error) => {
              let message = this.errorHandler.handleError(error);
              this.blocked = false;
              this._messagesService.addErrorMessage(message);
            }
          );
      },
      reject: () => {

      },
    });
  }

  confirmFalseRedo() {
    this.confirmationService.confirm({
      message:
        "Do you really want to Correct False Redo For Batch: " +
        this.searchedBatch.batchID +
        "?",
      header: "Confirmation",
      icon: "fa fa-question-circle",
      accept: () => {
        this.blocked = true;
        this.apgAdminService
          .changeFalseRedo(
            this.selectedLabId,
            this.searchedBatch,
            this.searchedBatch.redoCount
          )
          .subscribe(
            (result) => {
              this.searchedBatch = result.data;
              this._messagesService.addSuccessMessage({
                severity: "success",
                summary: "Corrected Redo!",
                detail:
                  "Redo has been changed to " + this.searchedBatch.batchID,
              });
              this.blocked = false;
            },
            (error) => {
              let msg = this.errorHandler.handleError(error);
              this._messagesService.addErrorMessage(msg);
              this.blocked = false;

            }
          );
      },
      reject: () => {

      },
    });
  }

  setRedoStep(status: string, redoStep: string) {
    this.findKit();
    this.selectedRedoReason = null;
    this.noRedoReasonConfiguredForLab = false;
  }

  redoButtonDisabledIf() {
    if (!this.selectedRedoReason || !this.selectedRedoReasonStep ||(!this.askForChannelDisabled && !this.selectedRedoReasonChannel) || 
    (this.selectedRedoReasonStep == "Redo_Lysis" && this.redoLysisDisabled()))
      return true;
    else if (this.selectedRedoReason != "Other") return false;
    else
      return !(this.enteredRedoReason && this.enteredRedoReason.trim() != "");
  }

  removeDisabledIf(): boolean {
    return !(
      this.searchedBatch &&
      this.searchedBatch.redoCount == 0 &&
      !["REDO", "COMPLETED", "REMOVED"].includes(
        this.searchedBatch.statusOfTheBatch
      ) &&
      !this.isMergedBatch() &&
      this.validRole
    );
  }

  removeUnnecessaryRedoDisabledIf(): boolean {
    return !(
      this.searchedBatch &&
      this.searchedBatch.redoCount > 0 &&
      !this.isMergedBatch() &&
      this.validRole
    );
  }

  changeFalseRedoDisabledIf(): boolean {
    return !(
      this.searchedBatch &&
      this.searchedBatch.redoCount > 0 &&
      !["REDO", "COMPLETED", "REMOVED"].includes(
        this.searchedBatch.statusOfTheBatch
      ) &&
      !this.isMergedBatch() &&
      !this.isRedoExtractionBatch() &&
      this.validRole &&
      !this.isReAnalyzedWetBatch()
    );
  }

  isMergedBatch(): boolean {
    return this.searchedBatch.wellType == WellType.WELL384;
  }

  isReAnalyzedWetBatch() {
    let batchExtension = this.searchedBatch.batchID.substring(
      this.searchedBatch.batchID.lastIndexOf("_") + 1
    );
    return (
      this.searchedBatch.createdFromAnalysis &&
      this.searchedBatch.swabType == "Wet" &&
      batchExtension.charAt(batchExtension.length - 1) == "Q"
    );
  }

  selectBatchToComplete() {
    this.searchSelection = "batch";
    this.parentBatches = [];
    let batchIdForSelection = this.searchedBatch.batchID;
    while (true) {
      this.parentBatches.unshift(batchIdForSelection);
      batchIdForSelection = batchIdForSelection.slice(0, -1);
      if (batchIdForSelection.endsWith("_")) {
        batchIdForSelection = batchIdForSelection.slice(0, -1);
        this.parentBatches.unshift(batchIdForSelection);
        break;
      }
    }
    this.removeUnnecessaryPopup = true;
  }

  removeUnnecessaryRedo() {
    let batchIdsTobeRemoved: string[] = [];
    let index = this.parentBatches.indexOf(this.selectedBatchIdToComplete) + 1;
    batchIdsTobeRemoved = this.parentBatches.slice(
      index,
      this.parentBatches.length
    );
    this.blocked = true;
    this.apgAdminService
      .removeUnnecessaryRedo(
        this.selectedLabId,
        this.selectedBatchIdToComplete,
        batchIdsTobeRemoved
      )
      .subscribe(
        (result) => {
          this._messagesService.addSuccessMessage({
            severity: "success",
            summary: "Batch Removed!",
            detail: result.data,
          });
          this.removeUnnecessaryPopup = false;
          this.selectedBatchIdToComplete = null;
          this.searchedBatch.statusOfTheBatch = "REMOVED";
          this.searchedBatch.version = this.searchedBatch.version + 1;
          this.blocked = false;
        },
        (error) => {
          this.blocked = false;
          let errorMessage = this.errorHandler.handleError(error);
          this._messagesService.addErrorMessage(errorMessage);
        }
      );
  }

  isRedoExtractionBatch() {
    if (this.searchedBatch.redoCount > 0) {
      let batchExtension = this.searchedBatch.batchID.substring(
        this.searchedBatch.batchID.lastIndexOf("_") + 1
      );
      return batchExtension.charAt(batchExtension.length - 1) == "E";
    }
    return false;
  }
  shipToSender() {
    this.blocked = true;
    this.shipToSenderDTO = new ShipToSenderDTO();
    this.shipToSenderDTO.shippedTimestamp = new Date();
    this.shipToSenderDTO.shippedUserPUID = this.puid;
    this.shipToSenderDTO.labId = this.selectedLabId;
    this.shipToSenderDTO.sample = this.sampleInfo.barcode;
    this.shipToSenderDTO.batchID = this.sampleInfo.analysisBatch;
    this.shipToSenderDTO.destination = this.destination;
    this.sampleInfo.shippedUserPUID = this.puid;
    this.sampleInfo.shippedTimestamp = new Date();
    this.apgAdminService.shipToSender(this.shipToSenderDTO).subscribe(
      (result) => {
        if (result == 1) {
          this._messagesService.addSuccessMessage({
            severity: "success",
            summary: "Shipped To Sender",
            detail: "Updated  " + result + "  Batch",
          });
          this.blocked = false;
          this.searchForSample(this.sampleInfo.barcode)
        } else {
          this._messagesService.addErrorMessage({
            severity: "error",
            summary: "Ship To Sender Failed",
            detail: "Couldn't Update  Batch",
          });
          this.blocked = false;
        }
      },
      (error) => {
        let errorMSG = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(errorMSG);
        this.blocked =false;
      }
    );
  }
  disableShiptoSender() {
    return !((
      this.sampleInfo.status == "COMPLETED" ||
      this.sampleInfo.status == "ANALYSIS_DONE" ||
      this.sampleInfo.status == "DATA_READY")&& (
      this.destination &&
      this.destination.trim() != "")
    );
  }
  getresultView() {
    return this.resultView;
  }

  getRedoResonsDetails(){
    this.selectedRedoReasonInfo = null;
    this.askForChannelDisabled = false;
    this.selectedRedoReasonStep = null;
    this.selectedRedoReasonChannel = null;
    this.redoReasons.forEach(readoReson => {
      if(this.selectedRedoReason == readoReson.reasonName){
        this.selectedRedoReasonInfo = readoReson.reasonInfo;
        this.askForChannelDisabled = !readoReson.askForChannel;
        if(readoReson.defaultRedoStep){
          if(readoReson.defaultRedoStep == "REDO_PCR"){
            this.selectedRedoReasonStep = "Redo_PCR";
          }else if(readoReson.defaultRedoStep == "REDO_LYSIS"){
            this.selectedRedoReasonStep = "Redo_Lysis";
          }
        }
      }
    });
    if(this.redoChannelList.length <1){
      this.askForChannelDisabled = true;
    }
  }

  findKit(){
    this.redoReasons = [];
    this.redoChannelList = [];
    this.masterDataService.getKitByName(this.searchedBatch.lab, this.searchedBatch.rtPCRKitVendor, "PCR Kit").subscribe(
      result => {
        if(result.data){
          this.pcrKitRedoInfoForBatch = result.data;
          this.redoReasons = result.data.kitRedoReason;
          if(result.data.channel1Gene){
            this.redoChannelList.push({label:result.data.channel1Gene , value:result.data.channel1Gene});
          }
          if(result.data.channel2Gene){
            this.redoChannelList.push({label:result.data.channel2Gene, value:result.data.channel2Gene});
          }
          if(result.data.channel3Gene){
            this.redoChannelList.push({label:result.data.channel3Gene, value:result.data.channel3Gene});
          }
          if(result.data.channel4Gene){
            this.redoChannelList.push({label:result.data.channel4Gene, value:result.data.channel4Gene});
          }
          if(result.data.channel5Gene){
            this.redoChannelList.push({label:result.data.channel5Gene, value:result.data.channel5Gene});
          }
        }
        if(this.redoReasons && this.redoReasons.length<1){
          //find active redo reasons for Lab
          this.findAllActiveRedoReasonsForLab();
        }else{
          this.redoReasons.sort((item1, item2) => item1.reasonCode.localeCompare(item2.reasonCode));
          this.redoReasonsPopup = true;
        }
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  findAllActiveRedoReasonsForLab(){
    this.masterDataService.getRedoReasons(this.selectedLab).subscribe(
      results => {
        if (!results) {
          this.redoReasonsPopup = true;
          this.noRedoReasonConfiguredForLab = true;
          return;
        }
        this.redoReasonsForLab = results.data;  
        this.redoReasonsForLab.forEach(ele => {
          if (ele.active) {
            this.redoReasons.push(ele);
          }
        });
        if(this.redoReasons && this.redoReasons.length<1){
          this.redoReasonsPopup = true;
          this.noRedoReasonConfiguredForLab = true;
          return;
        }
        this.redoReasons.sort((item1, item2) => item1.reasonCode.localeCompare(item2.reasonCode));
        this.redoReasonsPopup = true;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  onTabChange(event) {
    switch (event.index) {
      case 0:
        this.searchSelection="batch";
        break;
      case 1:
        this.searchSelection="sendOrder";
        break;
      default:
        break;
    }
  }

  fetchDelivery(deliveryId: string) {
    if(!deliveryId || deliveryId==''){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Delivery ID is empty',
        detail: 'Please input delivery id and hit enter or click on Go'
      })
      return;
    }
    this.deliveryId = deliveryId;
    this.blocked = true;
    this.apgAdminService.fetchDeliveryInfo(deliveryId).subscribe(
      (response) => {
        this.blocked = false;
        this.deliveryOrdersList = (response.data || []).map((order: any) => {
          return Object.assign({}, order);
        });
        this.deliveryOrdersList.sort((data1: Order, data2: Order) => {
          return data1.sampleId.localeCompare(data2.sampleId);
        });
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Delivery found',
          detail: 'Orders within delivery '+deliveryId+' fetched successfully'
        })
      }, (err) =>{
        this.blocked = false;
        this.deliveryOrdersList = [];
        if(err && err.status==404){
          this._messagesService.addErrorMessage({
            severity: 'error', summary: 'Delivery not found',
            detail: 'No order found with delivery '+deliveryId
          })
        }else{
          let message = this.errorHandler.handleError(err);
          this._messagesService.addErrorMessage(message);
        }
      }
    )
  }

  fetchInvoicedOrders() {
    if(!this.fromDate || !this.untilDate){
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Invalid',
        detail: 'Please select both from and until dates'
      })
      return;
    }
    let from = this.datePipe.transform(this.fromDate, invoiceDateFormat);
    let until = this.datePipe.transform(this.untilDate, invoiceDateFormat);
    this.blocked = true;
    this.apgAdminService.fetchInvoicedOrders(from, until).subscribe(
      (response) => {
        this.blocked = false;
        this.deliveryOrdersList = (response.data || []).map((order: any) => {
          return Object.assign({}, order);
        });
        this.deliveryOrdersList.sort((data1: Order, data2: Order) => {
          return data1.sampleId.localeCompare(data2.sampleId);
        });
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Success',
          detail: 'Invoiced orders fetched successfully'
        })
      }, (err) =>{
        this.blocked = false;
        this.deliveryOrdersList = [];
        if(err && err.status==404){
          this._messagesService.addErrorMessage({
            severity: 'error', summary: 'No invoiced order found',
            detail: 'No invoiced order found within selected date range'
          })
        }else{
          let message = this.errorHandler.handleError(err);
          this._messagesService.addErrorMessage(message);
        }
      }
    )
  }

  handleDeliveryRowSelect(event: any){
    if(!this.selectedDeliveryOrder || !this.selectedDeliveryOrder.delivery || !this.selectedDeliveryOrder.sampleId){
      this._messagesService.addWarningMessage({
        severity:'warn', summary:'Selected invalid order',
        detail: 'Could not find delivery and sample info for selected order, please refresh the delivery and try again'
      })
      return;
    }
    if(document.getElementById("deliveryOrderJsonId")){
      document.getElementById("deliveryOrderJsonId").innerHTML = ""
    }
    this.blocked = true;
    this.apgAdminService.fetchOrder(this.selectedDeliveryOrder.delivery, this.selectedDeliveryOrder.sampleId).subscribe(
      (response)=>{
        this.showDeliveryOrder = true;
        setTimeout(()=>{
          this.blocked = false;
          document.getElementById("deliveryOrderJsonId").innerHTML = JSON.stringify(response.data, undefined, 2);
        }, 100)
      },(err)=>{
        this.blocked = false;
        if(err && err.status==404){
          this._messagesService.addErrorMessage({
            severity: 'error', summary: 'Order not found',
            detail: 'No order found with sample '+this.selectedDeliveryOrder.sampleId +' in delivery '+this.selectedDeliveryOrder.delivery
          })
        }else{
          let message = this.errorHandler.handleError(err);
          this._messagesService.addErrorMessage(message);
        }
      }
    )
  }

  checkIfFieldIsDate(field){
    if(field && this.dateFields.indexOf(field)!=-1){
      return true;
    }
    return false;
  }

  checkIfFieldIsBoolean(field){
    if(field && this.boolenFields.indexOf(field)!=-1){
      return true;
    }
    return false;
  }

  exportInvoice(){
    var invoiceExport: InvoiceExport = {};
    var fileName = '';
    if(this.searchSelection==='delivery' && this.deliveryId){
      invoiceExport.type = 'delivery';
      invoiceExport.delivery = this.deliveryId;
      var today = new Date();
      fileName = 'Delivery_'+this.deliveryId+'_'+this.datePipe.transform(today, invoiceDateFormat)+'.xlsx';
    }else if(this.searchSelection==='invoice' && this.fromDate && this.untilDate){
      invoiceExport.type = 'dateRange';
      invoiceExport.from = this.datePipe.transform(this.fromDate, invoiceDateFormat)
      invoiceExport.until = this.datePipe.transform(this.untilDate, invoiceDateFormat)
      fileName = 'Invoice_'+invoiceExport.from+'_'+invoiceExport.until+".xlsx";
    }else{
      this._messagesService.addWarningMessage({
        severity: 'warn', summary: 'Invalid export data',
        detail: 'Invalid information to do an export, please search and try again'
      })
      return;
    }
    this.blocked = true;
    this.apgAdminService.exportInvoice(invoiceExport).subscribe(
      results => {
        this.blocked = false;
        var blob = new Blob([results.fileContent], { type: 'application/octet-stream' });
        this.saveFile(blob, fileName);
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Invoice downloaded',
          detail: 'Invoice has been exported successfully',
        });
      },
      error => {
        this.blocked = false;
        let errorHandler = new ErrorHandler();
        let message = errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    );
  }

  saveFile(data: any, filename?: string) {
    const blob = new Blob([data], { type: 'application/octet-stream' });
    saveByFileSaver(blob, filename);
  }

   
showPopUpForResult(){
  this.samplePopVisible = true;
}
searchForSample(searchID: string) {
    this.sampleSearch = false;
    if (["POS_EX", "NTC_EX", "PCR-PC", "PCR-NTC"].includes(searchID)) {
      this._messagesService.addErrorMessage({
        severity: "error",
        summary: "Invalid Barcode!",
        detail:
          "Can not Search with Controls...Please enter a valid Sample Barcode",
      });
      return;
    } else if (searchID === "NC-DUMMY") {
      this._messagesService.addErrorMessage({
        severity: "error",
        summary: "Invalid Barcode!",
        detail:
          "Can not Search with NC-DUMMY...Please enter a valid Sample Barcode",
      });
      return;
    }
    this.blocked = true;
    this.apgAdminService.getSampleInfo(this.selectedLabId, searchID).subscribe(
      (result: any) => {
        this.blocked = false;
        this.deliveryList = [];
        this.ordersOfSample = [];
        this.batchIDOfCON = [];
        this.batchIDOfEBE = [];
        this.statusOfBatchEBE = [];
        this.statusOfBatchCON = [];
        this.receivedEBE = [];
        this.receivedCON = [];
        this.dateToLocal='';
        this.positionCON='';
        this.postionEBE='';
        if (result.output != undefined && result.output != null) {
          result.output.forEach(fromObj => {
            this.dataForSampleSearch(fromObj);
                this.sampleID = fromObj.samples.barcode;
                this.deliveryList.push( fromObj.samples.delivery);
                this.ordersOfSample.push( fromObj.samples.order);
          });
          this.uniques = this.deliveryList.filter((item, i, ar) => ar.indexOf(item) === i);
          this.strMarker = this.getSTRMarkerValue(result);
          this.genevalue = this.getGeneTestsValue(result);
          this.parentalResult = this.getParentageResult(result);
          this.sampleSearch = true;
        } else {
          this._messagesService.addErrorMessage({
            severity: "error",
            summary: "No Data Found",
            detail: "Sample Data not found for barcode " + searchID,
          });
        }
        this.blocked = false;
      },
      (error) => {
        let errMsg = this.errorHandler.handleError(error);
        this.blocked = false;
        this._messagesService.addErrorMessage(errMsg);
      }
    );
  }
  dataForSampleSearch(fromObj) {
    if (fromObj.statusOfTheBatch == 'COMPLETED' && fromObj.workflow == "Royal Canine - CON") {
      this.dateToLocal = fromObj.completeBatchDateTime;
    }
    if (fromObj.workflow == "Royal Canine - EBE") {
      this.batchIDOfEBE.push(fromObj.batchID);
      this.statusOfBatchEBE.push(fromObj.statusOfTheBatch);
      this.row1 = fromObj.samples.positionRow;
      this.col1 = fromObj.samples.positionCol;
      this.postionEBE = this.getRowColStringFromPos(this.row1, this.col1);
      this.receivedEBE = fromObj.receivedDate.$date;
    } else if (fromObj.workflow == "Royal Canine - CON") {
      this.batchIDOfCON.push(fromObj.batchID);
      this.statusOfBatchCON.push(fromObj.statusOfTheBatch);
      this.row2 = fromObj.samples.positionRow;
      this.col2 = fromObj.samples.positionCol;
      this.positionCON = this.getRowColStringFromPos(this.row2, this.col2);
    }
  }
allOutputData:any=[];

 /**
 * Get the positional String from row and col number.
 * Ex: (1, 1) returns 'A1'
 * @param row
 * @param col
 */
  getRowColStringFromPos(row: number, col: number) {
    return this.rowHeaders384[row-1] + this.columnHeaders384[col-1];
  }
  
  getSTRMarkerValue(result) {
    let marker = [];
    let splitValue;
    let strData = [];
    let finalOutput = [];
    let finalSplitValues=[];
          result.output.forEach(samplesData => {
            if (samplesData.samples.result != undefined && samplesData.samples.result != null && samplesData.samples.result.str !=null && samplesData.samples.result.str != undefined ) {
              strData.push(samplesData.samples.result.str);
              for (let strIteration of strData) {
                marker.push(strIteration.markers);
              }
            }
          });
        marker.forEach(markerNames => {
          for (let iteratorValue of markerNames) {
            splitValue = iteratorValue.value;  
            strData = splitValue.split("/");
            strData.push(iteratorValue.markerName);
            finalSplitValues.push(strData);
          }
        });
        finalSplitValues.forEach(valueSet => {
          let arr = ["numerator", "denominator", "markerName"];
          let obj = {};
          for (let i = 0; i < valueSet.length; i++) {
            obj[arr[i]] = valueSet[i];
          }
          finalOutput.push(obj);
      });
    return finalOutput;
  }
  getGeneTestsValue(result) {
    let finalOutput = [];
    let obj = {};
      if(result.output !=null && result.output != undefined){
        result.output.forEach(fromOutput => {
            if(fromOutput.samples && fromOutput.samples.tests){
              fromOutput.samples.tests.forEach(codeValue => {
                obj = { code: codeValue.code, result: '' };
                if(fromOutput.samples.result !=null && fromOutput.samples.result != undefined && fromOutput.samples.result.tests !=null && fromOutput.samples.result.tests != undefined){
                  fromOutput.samples.result.tests.forEach(results => {
                  if (codeValue.code == results.code) {
                    obj = { code: results.code, result: results.result }
                  }
                });
              }
                finalOutput.push(obj);
              });
            }
        })
      }
      return finalOutput;
  }
  getParentageResult(result) {
   let strPResult=[];
   if(result.output !=null && result.output !=undefined){
    result.output.forEach(sampleCode => {
      if(sampleCode.samples.order.includes('STR-P')){
        if(sampleCode.samples.result !=null && sampleCode.samples.result != undefined && sampleCode.samples.result.strP != null && sampleCode.samples.result.strP != undefined){
          strPResult.push(sampleCode.samples.result.strP.result);
        }
      }
      });
    this.uniquesStrp = strPResult.filter((item, i, ar) => ar.indexOf(item) === i);
   }
    return this.uniquesStrp;
  }
}